import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';


@Injectable()
export class ModuleClearService {
    constructor() { }
    clearModules() {
        return new Observable((observer) => {
            localStorage.removeItem('1');
            localStorage.removeItem('2');
            localStorage.removeItem('3');
            localStorage.removeItem('4');
            localStorage.removeItem('5');
            localStorage.removeItem('6');
            localStorage.removeItem('7');
            localStorage.removeItem('8');
            localStorage.removeItem('9');
            localStorage.removeItem('10');
            localStorage.removeItem('11');
            localStorage.removeItem('12');
            localStorage.removeItem('13');
            localStorage.removeItem('14');
            localStorage.removeItem('15');
            localStorage.removeItem('16');
            observer.next("cleared");
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/module-clear.service.ts